module.exports = __webpack_public_path__ + "static/media/user-clock.e5541b1a.svg";